var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStripe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 48,
    viewBox: "0 0 70 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 69,
    height: 47,
    rx: 5.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_741_54377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0922 22.4116C16.0922 21.9192 16.4833 21.7298 17.1312 21.7298C18.06 21.7298 19.2333 22.0202 20.1622 22.5379V19.5707C19.1478 19.154 18.1456 18.9899 17.1312 18.9899C14.65 18.9899 13 20.3283 13 22.5632C13 26.0479 17.6444 25.4925 17.6444 26.995C17.6444 27.5757 17.1556 27.7652 16.4711 27.7652C15.4567 27.7652 14.1611 27.3358 13.1344 26.7551V29.7601C14.2711 30.2652 15.42 30.4798 16.4711 30.4798C19.0133 30.4798 20.7611 29.1793 20.7611 26.9192C20.7489 23.1566 16.0922 23.8257 16.0922 22.4116ZM24.3544 16.4647L21.3722 17.1212L21.36 27.2348C21.36 29.1036 22.7167 30.4798 24.5256 30.4798C25.5278 30.4798 26.2611 30.2904 26.6644 30.0631V27.5C26.2734 27.6642 24.3422 28.2449 24.3422 26.3762V21.8939H26.6644V19.2045H24.3422L24.3544 16.4647ZM30.4656 20.1388L30.27 19.2045H27.63V30.2525H30.6856V22.7652C31.4066 21.793 32.6289 21.9697 33.0078 22.1086V19.2045C32.6167 19.053 31.1867 18.7752 30.4656 20.1388ZM33.7533 19.2045H36.8211V30.2525H33.7533V19.2045ZM33.7533 18.2449L36.8211 17.5631V15L33.7533 15.6692V18.2449ZM43.2011 18.9899C42.0033 18.9899 41.2333 19.5707 40.8056 19.9748L40.6466 19.1919H37.9578V33.9141L41.0133 33.2449L41.0256 29.6717C41.4656 30 42.1133 30.4672 43.1889 30.4672C45.3767 30.4672 47.3689 28.649 47.3689 24.6465C47.3567 20.9848 45.34 18.9899 43.2011 18.9899ZM42.4678 27.6894C41.7467 27.6894 41.3188 27.4243 41.0256 27.096L41.0133 22.4116C41.3311 22.0455 41.7711 21.793 42.4678 21.793C43.58 21.793 44.35 23.0808 44.35 24.7348C44.35 26.4268 43.5922 27.6894 42.4678 27.6894ZM57 24.7727C57 21.5404 55.4844 18.9899 52.5878 18.9899C49.6788 18.9899 47.9188 21.5405 47.9188 24.7475C47.9188 28.5479 49.9967 30.4672 52.9788 30.4672C54.4333 30.4672 55.5333 30.1262 56.3644 29.6465V27.1212C55.5334 27.5505 54.58 27.8157 53.37 27.8157C52.1844 27.8157 51.1333 27.3864 50.9989 25.8965H56.9756C56.9756 25.7322 57 25.0757 57 24.7727ZM50.9622 23.5732C50.9622 22.1465 51.8056 21.553 52.5756 21.553C53.3211 21.553 54.1156 22.1465 54.1156 23.5732H50.9622Z",
    fill: "#6772E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_741_54377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 19,
    fill: "white",
    transform: "translate(13 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.3762abbf91c078a6685977f96bd4aacb.svg";
export { ForwardRef as ReactComponent };